export default __webpack_public_path__ + "static/media/logo.59c87a46.png";